import { useState } from "react";
import { toast } from "react-toastify";

export const useEmail = () => {
  const [isSending, setIsSending] = useState(false);

  const sendEmail = async (emailMsg, subject) => {
    setIsSending(true);

    const formData = new FormData();
    const licno = "Lic10";

    formData.append("licno", licno);
    formData.append("email", "contact@sagfinancials.com");
    formData.append("Subject", subject);
    formData.append("Content", emailMsg);

    // 🟡 Show "sending" toast
    const toastId = toast.loading("📤 Sending Message...");

    try {
      const response = await fetch("https://Custommail.dynode.in/api/mail/sendmail", {
        method: "POST",
        body: formData,
        // Prevent mobile browsers from opening response page
        headers: { "Accept": "application/json, text/plain, */*" },
      });

      // Some APIs return 200 with HTML, so check content type
      const contentType = response.headers.get("content-type");
      let result;
      if (contentType && contentType.includes("application/json")) {
        result = await response.json();
      } else {
        result = await response.text();
      }

      // ✅ Update toast to success
      toast.update(toastId, {
        render: "✅ Message sent successfully!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });

      // Return the raw response
      return result;

    } catch (error) {
      console.error("Email failed:", error);

      // ❌ Update toast to error
      toast.update(toastId, {
        render: "❌ Failed to send message. Please try again.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });

      throw error;

    } finally {
      setIsSending(false);
    }
  };

  return { sendEmail, isSending };
};
